import { computed } from 'vue';

export default function useGoalList(viewsService, viewParamsService, filterService, sort, goals) {
  const elements = computed(() => goals.value.filter((goal) => filterService.inFilter(goal)));

  const goalList = computed(() => sort(elements.value, [...viewParamsService.order.value]));

  return { goalList };
}
